import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import UserDatabases from '@Services/UserDatabases';

import './ResultsFiltersButtons.scss';

export default function ResultsFiltersButtons(props) {
  const { databaseId, limitTo, exclude, clear, disableButtons } = props;
  const isExcludeButtonHidden = UserDatabases.isRCSDatabase(databaseId) && Auth.isFeatureEnabled(FEATURES.hideRCSFiltersExcludeButton);

  return (
    <div className="u-els-padding o-els-flex-layout o-els-flex-layout--space-between results-filters-buttons">
      <div className="filter-buttons-left">
        <Button
          data-e2e="results-filters-limit"
          type="primary"
          size="small"
          onClick={limitTo}
          disabled={disableButtons}
          className="e2e-results-filters-limit">
          Limit to
        </Button>
        {!isExcludeButtonHidden && (
          <Button
            data-e2e="results-filters-exclude"
            type="secondary"
            size="small"
            onClick={exclude}
            disabled={disableButtons}
            className="e2e-results-filters-exclude">
            Exclude
          </Button>
        )}
      </div>
      <Button
        data-e2e="results-filters-clear"
        type="borderless"
        size="small"
        onClick={clear}
        disabled={disableButtons}
        className="u-els-color-linkblue e2e-results-filters-clear">
        Clear
      </Button>
    </div>
  );
}

export const propTypes = {
  databaseId: PropTypes.string.isRequired,
  limitTo: PropTypes.func.isRequired,
  exclude: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
  disableButtons: PropTypes.bool.isRequired,
};

ResultsFiltersButtons.propTypes = propTypes;
